import { createSlice } from "@reduxjs/toolkit";

const roomNoSlice = createSlice({
  name: "RoomNo",
  initialState: { number: null },
  reducers: {
    setRoomNo: (state, action) => {
      state.number = action.payload;
    },
    clearRoomNo: (state) => {
        state.number = null;
    }
  },
});

export const { setRoomNo, clearRoomNo } = roomNoSlice.actions;
export default roomNoSlice.reducer;
